import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Link } from '../../../web/src/components/navigation/link.jsx';
import { UseCaseIcon } from '../components/use-case-icon.jsx';
import { usePageTitle } from '../layout/use-page-title.js';
import { NotFoundPage } from '../pages/not-found.jsx';
import { getUseCase, USE_CASES } from './registry.jsx';

/**
 * Renders one use case from the registry: headline, lede, body, the mockup
 * screen, and links to the sibling use cases.
 * @returns {JSX.Element}
 */
export function UseCasePage() {
	const { lang, slug } = useParams();
	const { t } = useTranslation();
	const useCase = slug ? getUseCase(slug) : undefined;
	usePageTitle(
		useCase ? `usecase.${slug}.title` : 'site.useCases.title',
		useCase ? `usecase.${slug}.lede` : 'site.meta.useCases.description',
	);

	if (!useCase) {
		return <NotFoundPage />;
	}

	const others = USE_CASES.filter((u) => u.slug !== slug);

	return (
		<article className="use-case">
			<header className="use-case-hero">
				<p className="use-case-kicker">{t('site.useCases.title')}</p>
				<h1>{t(`usecase.${slug}.title`)}</h1>
				<p className="use-case-lede">{t(`usecase.${slug}.lede`)}</p>
			</header>
			<p className="use-case-body">{t(`usecase.${slug}.body`)}</p>
			<div className="use-case-mockup">
				<useCase.Screen />
			</div>
			<nav className="use-case-others" aria-label={t('site.useCases.browse')}>
				<h2>{t('site.useCases.browse')}</h2>
				<div className="use-case-grid">
					{others.map((u) => (
						<Link key={u.slug} to={`/${lang}/use-cases/${u.slug}/`} className="use-case-link card">
							<UseCaseIcon kind={u.icon} />
							<h3>{t(`usecase.${u.slug}.title`)}</h3>
							<p>{t(`usecase.${u.slug}.lede`)}</p>
						</Link>
					))}
				</div>
			</nav>
		</article>
	);
}
